import Context from '../context/index.js';
class EventContext {
    static get() {
        return this.context;
    }
    /**
     * Converts context to a valid json that events api supports: https://doc.sitecore.com/search/en/developers/events-api/index.html
     */
    static toJson() {
        if (this.context) {
            const contextJson = this.context.toJson();
            return {
                ...(contextJson.browser ? { browser: contextJson.browser } : {}),
                ...(contextJson.geo ? { geo: contextJson.geo } : {}),
                ...(contextJson.page
                    ? {
                        page: {
                            ...contextJson.page,
                            ...(contextJson.locale
                                ? {
                                    ...(contextJson.locale.country ? { locale_country: contextJson.locale.country } : {}),
                                    ...(contextJson.locale.language ? { locale_language: contextJson.locale.language } : {}),
                                }
                                : {}),
                        },
                    }
                    : {}),
                ...(contextJson.user ? { user: contextJson.user } : {}),
            };
        }
        return {};
    }
}
Object.defineProperty(EventContext, "context", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: new Context()
});
export default EventContext;
